window.$ = window.jQuery = require('jquery')
import isMobileChk from './is_mobile_chk.js'

export default function anchorLink(opt) {
  opt = opt || {}
  opt.speed = opt.speed || 500
  opt.offset = opt.offset || false
  opt.elements = opt.elements || '.anchorlink'
  opt.offsetElements = opt.offsetElements
  $(() => {
    $(opt.elements).on('click', function (event) {
      event.preventDefault()
      let diff = 0
      if (opt.offset) {
        if (isMobileChk()) {
          diff = $(opt.offsetElements).outerHeight()
        }
      }
      let href = $(event.target).attr('href')
      if (href === undefined) {
        href = $(event.target).parent(opt.elements).attr('href')
      }
      const speed = opt.speed
      const easing = 'swing'
      const domTarget = $(href === '#' || href === '' ? 'html' : href)
      const scrollTop = domTarget.offset().top - diff
      $('html, body').animate({ scrollTop: scrollTop }, speed, easing)
    })
    $('.wpcf7-submit').on('click', function (event) {
      const scrollTop2 = $('body').offset().top
      $('html, body').animate({ scrollTop: scrollTop2 }, 100)
    })
  })
}
